import 'css-chunksrc/client/pages/planzoneMembersPage/groupsList/skeletonDisplay/styles.scss';export default {
  "group": "_group_jb1kk_1",
  "groupHeader": "_groupHeader_jb1kk_5",
  "name": "_name_jb1kk_15",
  "members": "_members_jb1kk_19",
  "resourcesList": "_resourcesList_jb1kk_23",
  "list": "_list_jb1kk_30",
  "elem": "_elem_jb1kk_39"
};